import { render, staticRenderFns } from "./DesignTokenList.vue?vue&type=template&id=40dd5563&"
import script from "./DesignTokenList.vue?vue&type=script&lang=js&"
export * from "./DesignTokenList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports